import React from "react";
import { ChevronLeft, ChevronRight, Settings } from "lucide-react";

const Footer = () => {
  return (
    <div className='w-full border-b-[3px]  border-[#EDF0EF] bg-[#FAFBFB] p-4 md:h-[100px] h-[60px] flex items-center justify-between'>
          <div className={`p-4 mt-1 flex items-center md:w-[350px]`}>
        <Settings size={24} />
<span className="text-lg font-semibold text-black py-6">Settings</span>
      </div>
      <div className="flex justify-center gap-2 px-2 sm:px-4 md:px-6 py-2 w-full">
        {[
          { name: "License", link: "/license" },
          { name: "Terms and conditions", link: "/termsandcondition" },
          { name: "Privacy Policy", link: "/privacypolicy" },
          { name: "Data Usage", link: "/datausage" },
          { name: "FAQs", link: "/faqs" },
          { name: "API", link: "#" },
          { name: "Contact us", link: "/contactus" },
        ].map((item, index) => (
          <h1
            key={index}
            className="text-[14px] font-medium md:h-[44px] md:w-[130px] bg-[#F3F5F5] rounded-md p-3 sm:p-2 mb-0 flex justify-center items-center text-center sm:w-auto"
          >
            {item.link !== "#" ? (
              <a href={item.link} className="hover:underline text-left">
                {item.name}
              </a>
            ) : (
              item.name
            )}
          </h1>
        ))}
      </div>
    </div>
  );
};


export default Footer;
